import { Space, Typography } from 'antd';

const { Text } = Typography

export const SectionHeader = ({ title, description, style }) => {
  return (
    <Space size={0} direction='vertical' style={style}>
      <Text style={{ fontWeight: 700, fontSize: '1.7em' }}>
        {title}
      </Text>
      {description && (
        <Text type='secondary' style={{ fontSize: '1.1em' }}>
          {description}
        </Text>
      )}
    </Space>
  );
};
